export const UPDATE_INDUSTRIES_DATA = 'METADATA/UPDATE_INDUSTRIES_DATA';
export const UPDATE_UNCOUPLED_QUERY_VALIDATIONS_DATA =
  'METADATA/UPDATE_UNCOUPLED_QUERY_VALIDATIONS_DATA';
